import classes from './HeaderBanner.module.css';
import BBILogo from '../assets/Metal BBI Logo.png';
import { Link } from 'react-router-dom';
import ProfileMenu from './ProfileMenu';
import AdvancedSearch from '../helpers/search/AdvancedSearch';
import ResolveLogo from '../assets/bbiresolvelogo.svg'

const ResolveLink = () => {
  return (
    <a
      href="https://www.bbiresolve.com"
      target="_blank"
      rel="noreferrer"
      className={classes.resolveLink}
    >
      <img src={ResolveLogo} alt="BBI Resolve Logo" />
    </a>
  );
};

function HeaderBanner() {
  return (
    <div className={classes.headerBanner}>
      <Link to="/">
        <img className={classes.logo} alt="BBI Logo" src={BBILogo} />
        <div className={classes.title}>BBI Transportation</div>
      </Link>
      <div className={classes.filterHolder}>
        <AdvancedSearch />
      </div>
      <div className={classes.profileHolder}>
        <ResolveLink />
        <ProfileMenu />
      </div>
    </div>
  );
}

export default HeaderBanner;
